import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { variants, swipeConfidenceThreshold, swipePower } from './lib';
import ImageModal from './ImageModal';
import {
  CarouselWrapper,
  ImageWrapper,
  ControlsContainer,
  ControlButton,
  Pagination,
  PageMarker,
} from './styles';
import { ChevronLeftIcon, ChevronRightIcon } from '../../assets/svg';

const Carousel = ({ images, onPage }) => {
  const [[page, dir], setPage] = useState([0, 0]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setPage([0, 0]);
  }, [images]);

  const handlePaginate = dir => {
    if (page + dir < 0) {
      setPage([images.length - 1, dir]);
      onPage(images.length - 1);
    } else if (page + dir >= images.length) {
      setPage([0, dir]);
      onPage(0);
    } else {
      setPage([page + dir, dir]);
      onPage(page + dir);
    }
  };

  return (
    <CarouselWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
        delay: 0.25,
      }}
    >
      <AnimatePresence>
        <ImageModal
          key={modalOpen}
          open={modalOpen}
          handleClose={() => setModalOpen(false)}
          image={images[page]}
        />
      </AnimatePresence>
      <ImageWrapper>
        <AnimatePresence
          initial={false}
          custom={dir}
        >
          <motion.img
            onClick={() => setModalOpen(true)}
            key={page}
            src={require(`../../assets/${images[page]}Crop.png`)}
            custom={dir}
            variants={variants}
            initial='enter'
            animate='center'
            exit='exit'
            transition={{
              x: { type: 'spring', stiffness: 300, damping: 30 },
              opacity: { duration: 0.2 },
            }}
            drag='x'
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={1}
            onDragEnd={(_, { offset, velocity }) => {
              const swipe = swipePower(offset.x, velocity.x);
              if (swipe < -swipeConfidenceThreshold) {
                handlePaginate(1);
              } else if (swipe > swipeConfidenceThreshold) {
                handlePaginate(-1);
              }
            }}
          />
        </AnimatePresence>
        <ControlsContainer>
          <ControlButton onClick={() => handlePaginate(-1)}>
            <ChevronLeftIcon />
          </ControlButton>
          <ControlButton onClick={() => handlePaginate(1)}>
            <ChevronRightIcon />
          </ControlButton>
        </ControlsContainer>
      </ImageWrapper>
      <Pagination>
        {images.map((_, ind) => {
          return ind === page ? (
            <PageMarker
              key={`page-${ind}`}
              $active
            />
          ) : (
            <PageMarker
              key={`page-${ind}`}
              onClick={() => handlePaginate(ind - page)}
            />
          );
        })}
      </Pagination>
    </CarouselWrapper>
  );
};

export default Carousel;
